const stub_uspapi_ccpa = () => {
    (function () {
        var e = false;
        var c = window;
        var t = document;
        function r() {
            if (!c.frames["__uspapiLocator"]) {
                if (t.body) {
                    var a = t.body;
                    var e2 = t.createElement("iframe");
                    e2.style.cssText = "display:none";
                    e2.name = "__uspapiLocator";
                    a.appendChild(e2);
                }
                else {
                    setTimeout(r, 5);
                }
            }
        }
        r();
        function p() {
            var a = arguments;
            __uspapi.a = __uspapi.a || [];
            if (!a.length) {
                return __uspapi.a;
            }
            else if (a[0] === "ping") {
                a[2]({ gdprAppliesGlobally: e, cmpLoaded: false }, true);
            }
            else {
                __uspapi.a.push([].slice.apply(a));
            }
        }
        function l(t2) {
            var r2 = typeof t2.data === "string";
            try {
                var a = r2 ? JSON.parse(t2.data) : t2.data;
                if (a.__cmpCall) {
                    var n = a.__cmpCall;
                    c.__uspapi(n.command, n.parameter, function (a2, e2) {
                        var c2 = {
                            __cmpReturn: {
                                returnValue: a2,
                                success: e2,
                                callId: n.callId
                            }
                        };
                        t2.source.postMessage(r2 ? JSON.stringify(c2) : c2, "*");
                    });
                }
            }
            catch (a2) {
            }
        }
        if (typeof __uspapi !== "function") {
            c.__uspapi = p;
            __uspapi.msgHandler = l;
            c.addEventListener("message", l, false);
        }
    })();
};
export { stub_uspapi_ccpa };
